import { render, staticRenderFns } from "./xszz.vue?vue&type=template&id=7fdf87f8&scoped=true"
import script from "./xszz.vue?vue&type=script&lang=js"
export * from "./xszz.vue?vue&type=script&lang=js"
import style0 from "./xszz.vue?vue&type=style&index=0&id=7fdf87f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fdf87f8",
  null
  
)

export default component.exports